import React, { memo } from "react";

import type { BackdropProps } from "./backdrop.types";

export const Backdrop = ({ open, onClick, zIndex, onWheel }: BackdropProps) => {
  return (
    <div
      className={`backdrop overlay dark`}
      data-is-open={open}
      style={{ zIndex: open ? zIndex || 1201 : -1 }}
      onClick={onClick}
      onWheel={onWheel}
      data-testid="backdrop-element"
      tabIndex={-1}
    />
  );
};

export default memo(Backdrop);
